"use client"

import { NavLink } from "../../ui/NavLink";




export const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 md:py-8">
        <div className="text-center text-xs md:text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} Cabukaka. Tous droits réservés.</p>
          <div className="flex flex-wrap justify-center gap-3 md:gap-6 mt-2">
            <NavLink to="/conditions" className="hover:text-orange-500 transition-colors">
              Conditions générales
            </NavLink>
            <NavLink to="/politique-confidentialite" className="hover:text-orange-500 transition-colors">
              Confidentialité
            </NavLink>
            <NavLink to="/contact" className="hover:text-orange-500 transition-colors">
              Contact
            </NavLink>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;